import Vue from 'vue'
import gql from 'graphql-tag'
import AWS from 'aws-sdk'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { User } from '@/modules/User/interfaces/user'
import { Ticket, TicketInput } from '@/modules/Ticket/interfaces/ticket'
import { SnackType } from '@/interfaces/snack'
import { File, FileToSave } from '@/modules/File/interfaces/file'
import { STSCredential } from '@/interfaces/sts-credential'
import { showErrors, showNotification } from '@/utils/snack'
import { fileSizeFormat } from '@/utils/fileSize'
import { escapeLineBreak } from '@/utils/stringParser'
import { dateTimeToUnix } from '@/utils/dateTime'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppLightModal from '@/components/AppLightModal.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppMarkdownEditor from '@/components/AppMarkdownEditor.vue'
import TicketProps from '@/modules/Ticket/components/TicketProps.vue'
import { newTicket } from '@/modules/Ticket/gql/ticket.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppTextField,
    AppTextarea,
    AppLightModal,
    AppSearch,
    AppMarkdownEditor,
    TicketProps
  }
})
export default class TicketNew extends Vue {
  windowSize = {
    w: 0,
    h: 0
  }

  maxHeight = 0
  newTicketValid = true

  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Ticket',
      to: { name: 'TicketDashborad' }
    },
    {
      text: 'Create Ticket'
    }
  ]

  newTicketInput: TicketInput = {
    name: '',
    content: '',
    expectedTime: '',
    priority: 'GENERAL',
    labels: [],
    assignees: [],
    supervisors: [],
    relatedTickets: [],
    detail: {
      text: '',
      files: [],
      filesToDel: [],
      filesToSave: [],
      editting: true
    }
  }

  fileType = ''
  fileUploadDialog = false
  fileToUpload: File | null = null
  fileUploadedSize: number = 0
  filesUploaded: FileToSave[] = []
  awsS3Prefix = process.env.VUE_APP_S3_URL
  bucketPrefix = process.env.VUE_APP_BUCKET_PREFIX

  stsCredential: STSCredential | null = null

  filesLoading = false

  acceptFileTypes = `
    .doc, .docx, .xml, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,
    application/pdf, image/*
  `

  @State(state => state.user.me) me!: User

  mounted () {
    this.onResize()
    this.newTicketInput.expectedTime = this.$moment().format('YYYY-MM-DD')
    this.newTicketInput.detail = {
      text: '',
      files: [],
      filesToDel: [],
      filesToSave: [],
      editting: true
    }
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
    this.maxHeight = this.windowSize.h - 100
  }

  async submitNewTicket () {
    const { name, expectedTime, labels, assignees, supervisors, relatedTickets, priority, detail } = this.newTicketInput
    if (name === '' || !detail) {
      return false
    }
    let { text, filesToSave } = detail

    const content = escapeLineBreak(text)
    const labelIds = labels.map(label => Number(label.id))
    const assigneeIds = assignees.map(assignee => assignee.id)
    const supervisorIds = supervisors.map(supervisor => supervisor.id)
    const relatedTicketIds = relatedTickets.map(relatedTicket => relatedTicket.id)

    let filesStr: FileToSave[] = []

    filesToSave.map((file: FileToSave) => {
      const fileItem: FileToSave = {
        url: file.url,
        name: file.name,
        size: file.size.toString(),
        type: 'TICKET_ATTACHMENT'
      }
      filesStr.push(fileItem)
    })
    try {
      const result = await this.$apollo.mutate({
        mutation: newTicket,
        variables: {
          ticketInput: {
            name,
            content,
            expectedTime: dateTimeToUnix(expectedTime || '') + '',
            labelIds,
            assigneeIds,
            supervisorIds,
            relatedTicketIds,
            priority
          },
          files: filesStr
        }
      })
      showNotification({
        msg: 'Label created successfully',
        type: SnackType.Success
      })
      this.$router.push({ name: 'TicketDashborad' })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  allowedDates (val: string) {
    return this.$moment().diff(val, 'days') > 0
  }

  removeFile (index: number) {
    const { filesUploaded } = this
    this.filesUploaded = this.$R.remove(index, 1, filesUploaded)
  }

  fileSizeFormat (size: any) {
    return fileSizeFormat(size)
  }
}
